import React, { useState } from 'react';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import { isAllowed } from '../../../../Services/acl.service';
import Tooltip from '../../../../Components/Popup/Tooltip';
import Text from '../../../../Components/Base/Text/Text';
import { useEffectAsync } from '../../../../helpers';
import { useLazyUserNcziProfileQuery } from '../../../../graphql/graphql';
import { useNCZIContext } from '../../Services/NCZIContext';
import NCZIPatient from '../NCZIPatient/NCZIPatient';
import PatientVerifyInformationsModal from './PatientVerifyInformationsModal';

interface Props {
	patientId: string;
}

const PatientVerifyInformationsButton: React.FC<Props> = ({ patientId }) => {
	const [verifyInformationsModalOpen, setVerifyInformationsModalOpen] =
		useState<boolean>(false);
	const isNcziEnabled = isAllowed('patient_health_ezdravie');

	const disabledButton = (
		<LinkButton
			title='patientTreatment.profile.verifyInformations.title'
			theme={Theme.DISABLED}
			onClick={() => {}}
		/>
	);
	const enabledButton = (
		<LinkButton
			title='patientTreatment.profile.verifyInformations.title'
			theme={Theme.BLUE}
			onClick={() => setVerifyInformationsModalOpen(true)}
		/>
	);

	return (
		<>
			{isNcziEnabled ? (
				enabledButton
			) : (
				<>
					<Tooltip
						trigger={disabledButton}
						position='bottom left'
						customStyle={{ width: 'fit-content' }}>
						<Text tx={'nczi.needSetup'} />
					</Tooltip>
				</>
			)}
			<PatientVerifyInformationsModal
				opened={verifyInformationsModalOpen}
				patientId={patientId}
				onClose={() => setVerifyInformationsModalOpen(false)}
			/>
		</>
	);
};

export default PatientVerifyInformationsButton;
